import s from './home.module.css';
import { useModal } from '@/lib/ModalContext';

export default function CTABanner() {
  const { setOpen } = useModal();
  return (
    <section>
      <div className="container">
        <div className={s.cta}>
          <h2 className={s.ctaTitle}>Get on the list. Get matched.</h2>
          <p className={s.ctaSub}>
            Private beta opens this summer. Waitlist gets priority access plus a free intake conversation
            with ELARIA when your matter window opens.
          </p>
          <div className={s.ctaRow}>
            <button className={`${s.btn} ${s.btnPrimary}`} onClick={() => setOpen('intake')}>Get matched with an attorney</button>
            <button className={`${s.btn} ${s.btnSecondary}`} onClick={() => setOpen('waitlist')}>Join the waitlist</button>
          </div>
        </div>
      </div>
    </section>
  );
}
